import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { CustomUserCmsComponents } from '@core/const';
import {
  AutofocusDirective,
  CountdownComponent,
  FormFieldComponent,
  PersonalDataAgreeTextComponent,
  PhoneFormatPipe,
  PhoneMaskFixDirective,
  SdvorButtonComponent,
  SdvorLinkComponent,
  SdvorNavigationArrowComponent,
  SdvorSpinnerComponent,
} from '@sdvor/shared/ui';
import { ConfigModule } from '@spartacus/core';
import { provideNgxMask } from 'ngx-mask';
import { LoginByCodeFormComponent, LoginByPasswordFormComponent } from './forms';
import { LoginFormComponent } from './login-form.component';

@NgModule({
  declarations: [LoginFormComponent, LoginByPasswordFormComponent, LoginByCodeFormComponent],
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgTemplateOutlet,
    AsyncPipe,
    RouterLink,
    ReactiveFormsModule,
    AutofocusDirective,
    PhoneMaskFixDirective,
    PersonalDataAgreeTextComponent,
    FormFieldComponent,
    SdvorButtonComponent,
    SdvorLinkComponent,
    CountdownComponent,
    SdvorNavigationArrowComponent,
    SdvorSpinnerComponent,
    ConfigModule.withConfig({
      cmsComponents: {
        [CustomUserCmsComponents.ReturningCustomerLoginComponent]: {
          component: LoginFormComponent,
        },
      },
    }),
    PhoneFormatPipe,
  ],
  providers: [provideNgxMask()],
})
export class LoginFormModule {}
